<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" :width="width" :height="height"><g :fill="_secondaryfill"><path d="M54,35H29V10c0-0.552-0.447-1-1-1C13.112,9,1,21.112,1,36s12.112,27,27,27s27-12.112,27-27 C55,35.448,54.553,35,54,35z" :fill="fill"></path> <path d="M36,1c-0.553,0-1,0.448-1,1v26c0,0.552,0.447,1,1,1h26c0.553,0,1-0.448,1-1 C63,13.112,50.888,1,36,1z"></path></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>